import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const StakePushGradientCoin: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="StakePushGradientCoin"
      illustration={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={restProps?.width ?? "24"}
          height={restProps?.height ?? "24"}
          viewBox="0 0 48 48"
          fill="none"
          {...props}
        >
          <ellipse
            cx="24.1157"
            cy="25.9367"
            rx="24"
            ry="22.5634"
            fill="black"
          />
          <ellipse
            cx="24.1157"
            cy="23.1644"
            rx="24"
            ry="22.6644"
            fill="url(#paint0_linear_8448_17387)"
          />
          <ellipse
            cx="23.9341"
            cy="22.9959"
            rx="19.6577"
            ry="18.5638"
            fill="black"
          />
          <ellipse
            cx="23.9341"
            cy="25.5322"
            rx="19.6577"
            ry="18.8792"
            fill="url(#paint1_linear_8448_17387)"
          />
          <path
            d="M24.1155 36.5247C25.5127 36.5247 26.7119 35.6875 27.2448 34.4884C27.3741 34.1964 27.1584 33.8677 26.8392 33.8677H21.3925C21.0733 33.8677 20.8562 34.1957 20.9869 34.4884C21.5198 35.6875 22.719 36.5247 24.1162 36.5247"
            fill="white"
          />
          <path
            d="M31.8825 30.2874C31.0593 30.2874 30.3922 29.6203 30.3922 28.7971V23.3834C30.3922 20.4496 28.3784 17.9869 25.6582 17.2996C25.5583 16.5263 24.8989 15.9275 24.0978 15.9275C23.2967 15.9275 22.6321 16.5313 22.5366 17.309C20.0954 17.9426 18.2327 20.0089 17.8975 22.557C17.8925 22.5943 17.8874 22.631 17.883 22.6689C17.8767 22.7195 17.8716 22.7695 17.8678 22.8207C17.864 22.8719 17.8596 22.9225 17.8564 22.9731C17.8533 23.0161 17.8501 23.0572 17.8482 23.1002C17.8444 23.1855 17.8419 23.2721 17.8419 23.3594V28.7965C17.8419 29.6159 17.1812 30.2804 16.363 30.2868C15.9729 30.2899 15.6504 30.5909 15.6504 30.9823V30.9886C15.6504 31.3756 15.9646 31.6898 16.3516 31.6898H31.8793C32.2663 31.6898 32.5805 31.3756 32.5805 30.9886C32.5824 30.6023 32.2682 30.288 31.8812 30.288L31.8825 30.2874Z"
            fill="white"
          />
          <path
            d="M28.9541 16.2549C30.8338 16.6578 32.2692 18.2755 32.4461 20.1906C32.4658 20.403 32.651 20.5615 32.8674 20.5405C32.9702 20.5309 33.0634 20.4812 33.1301 20.4023C33.1954 20.3227 33.2274 20.2219 33.2179 20.1192C33.1138 19.001 32.6632 17.9672 31.9139 17.1267C31.17 16.2943 30.2029 15.7308 29.116 15.4974C29.0888 15.4919 29.0616 15.4885 29.0351 15.4885C28.8567 15.4885 28.6948 15.6131 28.6567 15.7948C28.6117 16.0037 28.7451 16.2093 28.9541 16.2542V16.2549Z"
            fill="white"
          />
          <path
            d="M29.3887 13.7627C32.3131 14.3895 34.5481 16.9083 34.8245 19.8865C34.8442 20.0988 35.0293 20.2561 35.2457 20.2363C35.3485 20.2268 35.4417 20.1771 35.5084 20.0982C35.5738 20.0185 35.6058 19.9178 35.5962 19.815C35.4445 18.1687 34.7789 16.6436 33.6736 15.4069C32.5772 14.1792 31.1514 13.3489 29.552 13.0052C29.5248 12.9997 29.4976 12.9963 29.471 12.9963C29.2927 12.9963 29.1308 13.1209 29.0926 13.3026C29.0464 13.5115 29.1804 13.7171 29.3894 13.762L29.3887 13.7627Z"
            fill="white"
          />
          <path
            d="M19.2748 16.2548C19.4837 16.2099 19.6171 16.003 19.5722 15.7941C19.5327 15.6123 19.3721 15.4878 19.1938 15.4878C19.1672 15.4878 19.14 15.4912 19.1128 15.4966C18.0266 15.7294 17.0595 16.2929 16.3149 17.1259C15.5656 17.9651 15.1137 19.0003 15.011 20.1184C15.0014 20.2212 15.0327 20.3219 15.0987 20.4016C15.1641 20.4812 15.2587 20.5309 15.3615 20.5397C15.5792 20.5595 15.763 20.4016 15.7827 20.1899C15.9597 18.2775 17.3964 16.6591 19.2748 16.2555V16.2548Z"
            fill="white"
          />
          <path
            d="M18.8407 13.7626C19.0496 13.7177 19.183 13.5108 19.1381 13.3019C19.0986 13.1202 18.938 12.9956 18.7597 12.9956C18.7325 12.9956 18.7059 12.999 18.6787 13.0045C17.078 13.3481 15.6535 14.1784 14.5571 15.4062C13.4519 16.6435 12.7876 18.168 12.6345 19.8143C12.625 19.9171 12.6563 20.0178 12.7223 20.0974C12.7876 20.1771 12.8822 20.2267 12.985 20.2356C13.2014 20.2553 13.3865 20.0974 13.4063 19.8858C13.6819 16.9089 15.9169 14.3915 18.8407 13.7633V13.7626Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_8448_17387"
              x1="24.1157"
              y1="0.5"
              x2="24.1157"
              y2="45.8289"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D267FC" />
              <stop offset="0.48" stopColor="#896FFF" />
              <stop offset="0.945" stopColor="#71F0B1" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_8448_17387"
              x1="23.9341"
              y1="6.65308"
              x2="23.9341"
              y2="44.4114"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D267FC" />
              <stop offset="0.48" stopColor="#896FFF" />
              <stop offset="0.945" stopColor="#71F0B1" />
            </linearGradient>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default StakePushGradientCoin;
